import { createSuccessAction } from '../../../redux-util/async-helpers';
import { LIST_GROUPS, GET_GROUP } from '../../bridge-methods';
import { createReducer } from '../../../redux-util/general-helpers';

const handlers = {
  [createSuccessAction(LIST_GROUPS).type]: (state, action) => {
    const newState = {
      ...state,
    };
    action.data.content.forEach(g => {
      newState[g.id] = g;
    });

    return newState;
  },
  [createSuccessAction(GET_GROUP).type]: (state, action) => {
    return {
      ...state,
      [action.data.group.id]: action.data.group,
    };
  },
};

export default createReducer({}, handlers);



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/groups/data/reducer.js